const DEBUG = true;
const BH_APP_API_URL = "https://bh-app-api.bombayhair.ca/api/v1";
const WISHLIST_END_POINT = "/wishlist";
const WISHLIST_API_URL = `${BH_APP_API_URL}${WISHLIST_END_POINT}`;
const GET_WISHLIST_DATA_URL = `${WISHLIST_API_URL}/get-data`;
const TOGGLE_WISHLIST_DATA_URL = `${WISHLIST_API_URL}/toggle`;
const WISHLIST_STATUS_URL = `${WISHLIST_API_URL}/status`;
const BH_APP_KEY = "bh_app_8e98yuweuiwer7uirtew";
let CUSTOMER_ID = null;

const showToast = (message) => {
  Toastify({
    text: message,
    duration: 3000,
    close: true,
    gravity: "bottom",
    position: "right",
    style: { background: "#cd0c63" },
    stopOnFocus: true,
    escapeMarkup: false,
  }).showToast();
};

const printBrowserConsole = (message, style = "color: #008b00ff; font-weight: bold", ...args) => {
  if (DEBUG) {
    if (typeof message === "string") {
      console.log(`%c${message}`, style, ...args);
    } else {
      console.log(message, ...[...args]);
    }
  }
};

// ─── variantId sanitizer ───────────────────────────────────────────────────────
// Shopify GIDs like "gid://shopify/ProductVariant/12345678" must be stripped
// to the numeric part before sending to /cart/add.js
const sanitizeVariantId = (variantId) => {
  if (!variantId) return null;
  // If it's already numeric, return as-is
  if (/^\d+$/.test(String(variantId).trim())) return String(variantId).trim();
  // Extract numeric ID from GID string
  const match = String(variantId).match(/\/(\d+)(?:\?|$)/);
  if (match) {
    printBrowserConsole(`Sanitized GID variantId: ${variantId} → ${match[1]}`);
    return match[1];
  }
  // Last resort — return as-is and let Shopify throw a clear error
  return String(variantId).trim();
};

// ─── Redirect ─────────────────────────────────────────────────────────────────

const redirectToWishlistPage = () => {
  const wishlistHeaderButton = document.getElementById("wishlist");
  wishlistHeaderButton?.addEventListener("click", () => {
    window.location.href = "/pages/favorites";
  });
};

const init = () => {
  printBrowserConsole("Initializing wishlist script...");
  redirectToWishlistPage();
  printBrowserConsole("Wishlist script initialized");
};

// ─── Count bubble ─────────────────────────────────────────────────────────────

const initWishlistsCount = (count) => {
  const el = document.querySelector(".wishlist-count-bubble");
  if (el) el.innerHTML = count;
};

const updateFavoritesCount = (status) => {
  const el = document.querySelector(".wishlist-count-bubble");
  if (!el) return;
  const current = parseInt(el.innerHTML) || 0;
  el.innerHTML = status === "added" ? current + 1 : Math.max(0, current - 1);
};

// ─── Empty state ──────────────────────────────────────────────────────────────

const showEmptyStateIfNeeded = () => {
  const wishlistPage = document.querySelector(".wishlist-page");
  const remaining = document.querySelectorAll(".wishlist-item");
  if (remaining.length === 0 && wishlistPage) {
    wishlistPage.innerHTML = '<div class="ib-wishlist-no-items">No Items Available!</div>';
  }
};

// ─── Overlay loader ───────────────────────────────────────────────────────────

const showWishlistOverlayLoader = () => {
  if (document.getElementById("wishlist-overlay-loader")) return;
  const overlay = document.createElement("div");
  overlay.id = "wishlist-overlay-loader";
  overlay.innerHTML = `
    <div class="wishlist-loader-content">
      <div class="spinner"></div>
      <p>Adding items to cart...</p>
    </div>
  `;
  document.body.appendChild(overlay);
};

const removeWishlistOverlayLoader = () => {
  document.getElementById("wishlist-overlay-loader")?.remove();
};

// ─── API ──────────────────────────────────────────────────────────────────────

const toggleWishlist = async (url, customer_id, item) => {
  const productId    = item.getAttribute("data-product-id");
  const variantId    = item.getAttribute("data-variant-id");
  const productTitle = item.getAttribute("data-product-title");
  const productPrice = item.getAttribute("data-product-price");
  const productImage = item.getAttribute("data-product-image");
  const productUrl   = item.getAttribute("data-product-url");

  const product = {
    id: productId,
    variantId,
    title: productTitle,
    price: productPrice,
    image: productImage,
    url: productUrl,
  };

  const toggled = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: BH_APP_KEY,
    },
    body: JSON.stringify({ customer_id, product }),
  });

  const result = await toggled.json();
  printBrowserConsole("toggleWishlist result:", undefined, result);

  if (result.success) {
    const heartIcon = item.querySelector("i");
    if (result.added) {
      updateFavoritesCount("added");
      if (heartIcon) {
        heartIcon.classList.remove("fa-heart-o");
        heartIcon.classList.add("fa-heart");
      }
    } else {
      updateFavoritesCount("removed");
      if (heartIcon) {
        heartIcon.classList.remove("fa-heart");
        heartIcon.classList.add("fa-heart-o");
      }
    }
    showToast(`<strong>${productTitle}</strong> ${result.message}`);
  }
  return result;
};

const getWishlistData = async (url, customer_id) => {
  const response = await fetch(`${url}?customerId=${customer_id}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: BH_APP_KEY,
    },
  });
  const result = await response.json();
  if (result.success) return result.data;
  printBrowserConsole("Error fetching wishlist data:", result.message);
  return [];
};

const checkWishlistStatus = async (url, customer_id, product_id) => {
  const response = await fetch(`${url}/${customer_id}/${product_id}`, {
    method: "GET",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      Authorization: BH_APP_KEY,
    },
  });
  const result = await response.json();
  return result.success ? result.data.isWishlisted : false;
};

// KEY FIX: sanitizeVariantId() called here before every /cart/add.js call
const addToCart = async (rawVariantId, quantity = 1) => {
  const variantId = sanitizeVariantId(rawVariantId);
  if (!variantId) throw new Error("Missing variantId");

  printBrowserConsole(`addToCart → variantId: ${variantId}`);

  const res = await fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity }),
  });

  if (!res.ok) {
    const errBody = await res.json().catch(() => ({}));
    console.error("addToCart failed:", errBody);
    throw new Error(errBody?.description || "Add to cart failed");
  }

  const json = await res.json();
  window.SLIDECART_UPDATE?.();
  return json;
};

// ─── Wishlist page functions ───────────────────────────────────────────────────

const initIfUserLoggedIn = async () => {
  if (window.cffCustomer) {
    CUSTOMER_ID = window.cffCustomer.id;
    printBrowserConsole(`User is logged in with ID: ${CUSTOMER_ID}`);
    const wishlistedData = await getWishlistData(GET_WISHLIST_DATA_URL, CUSTOMER_ID);
    initWishlistsCount(wishlistedData.length);
  }
};

const addProductToWishlist = () => {
  const favoriteItems = document.querySelectorAll(".ib-favorite-heart");
  favoriteItems.forEach(async (item) => {
    const productId = item.getAttribute("data-product-id");
    const isWishlisted = await checkWishlistStatus(WISHLIST_STATUS_URL, CUSTOMER_ID, productId);
    const heartIcon = item.querySelector("i");

    if (heartIcon) {
      heartIcon.classList.remove("fa-heart", "fa-heart-o", "fa-spinner", "fa-spin");
      heartIcon.classList.add(isWishlisted ? "fa-heart" : "fa-heart-o");
    }

    if (!item.dataset.listenerAttached) {
      item.addEventListener("click", async function () {
        const icon = item.querySelector("i");
        icon?.classList.add("fa-spinner", "fa-spin");
        await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, item);
        icon?.classList.remove("fa-spinner", "fa-spin");
      });
      item.dataset.listenerAttached = "true";
    }
  });
};

const removeIndividualWishlistItem = () => {
  document.querySelectorAll(".remove-wishlist-item").forEach((button) => {
    button.addEventListener("click", async () => {
      button.disabled = true;
      button.textContent = "Removing...";

      const row = button.closest(".wishlist-item");
      const wishlistPage = document.querySelector(".wishlist-page");

      await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, button)
        .then(() => {
          printBrowserConsole("Product removed from wishlist successfully");
          row.remove();
          const remainingItems = document.querySelectorAll(".wishlist-item");
          if (remainingItems.length === 0) {
            wishlistPage.innerHTML = '<div class="ib-wishlist-no-items">No Items Available!</div>';
          }
        })
        .catch((error) => {
          printBrowserConsole("Error removing product from wishlist:", error);
          button.disabled = false;
          button.textContent = "Remove";
        });
    });
  });
};

const addIndividualWishlistItemToCart = () => {
  document.querySelectorAll(".move-wishlist-to-cart").forEach((button) => {
    button.addEventListener("click", async () => {
      button.disabled = true;
      button.textContent = "Adding...";

      const variantId    = button.getAttribute("data-variant-id");
      const productTitle = button.getAttribute("data-product-title");
      const row          = button.closest(".wishlist-item");
      const wishlistPage = document.querySelector(".wishlist-page");

      await addToCart(variantId)  // sanitizeVariantId runs inside addToCart
        .then(async () => {
          printBrowserConsole(`Product ${productTitle} added to cart successfully`);
          await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, button).then(() => {
            printBrowserConsole(`Product ${productTitle} removed from wishlist`);
            row.remove();
            showToast(`<strong>${productTitle}</strong> has been added to your cart.`);
            const remainingItems = document.querySelectorAll(".wishlist-item");
            if (remainingItems.length === 0) {
              wishlistPage.innerHTML = '<div class="ib-wishlist-no-items">No Items Available!</div>';
            }
          });
        })
        .catch((error) => {
          printBrowserConsole(`Error adding ${productTitle} to cart:`, error);
          button.disabled = false;
          button.textContent = "Add to Cart";
        });
    });
  });
};

const addAllWishlistItemsToCart = () => {
  const moveAllButton = document.getElementById("move-all-to-cart");

  if (!moveAllButton) {
    printBrowserConsole("Move All to Cart button not found");
    return;
  }

  // Guard against double-binding (important if this function is ever called again)
  if (moveAllButton.dataset.listenerAttached === "true") return;
  moveAllButton.dataset.listenerAttached = "true";

  moveAllButton.addEventListener("click", async () => {
    moveAllButton.disabled    = true;
    moveAllButton.textContent = "Moving...";

    showWishlistOverlayLoader();

    const wishlistPage = document.querySelector(".wishlist-page");

    // ── CORE FIX ────────────────────────────────────────────────────────────
    // Read product data from the <tr data-product="..."> attribute instead of
    // from individual buttons.  This means:
    //   1. Each product is processed exactly ONCE regardless of how many
    //      duplicate buttons exist in the row (desktop + mobile).
    //   2. The variantId is read from the Liquid-rendered JSON on the row,
    //      which is the raw value from the metafield — sanitizeVariantId()
    //      then normalises GIDs before the /cart/add.js call.
    const rows = document.querySelectorAll(".wishlist-item");
    const seenProductIds = new Set();

    for (const row of rows) {
      let product;
      try {
        product = JSON.parse(row.getAttribute("data-product") || "{}");
      } catch {
        printBrowserConsole("Could not parse data-product on row, skipping");
        continue;
      }

      const productId = String(product.id || "");
      if (!productId || seenProductIds.has(productId)) continue;
      seenProductIds.add(productId);

      // Prefer the parsed data; fall back to the first matching button's attribute
      const rawVariantId =
        product.variantId ||
        row.querySelector(".move-wishlist-to-cart")?.getAttribute("data-variant-id");

      const productTitle = product.title || "";

      printBrowserConsole(`Processing: "${productTitle}" — raw variantId: ${rawVariantId}`);

      // Use the first .move-wishlist-to-cart button in the row to call toggleWishlist
      // (it carries all the needed data-* attributes)
      const buttonForToggle = row.querySelector(".move-wishlist-to-cart");
      if (!buttonForToggle) continue;

      try {
        // sanitizeVariantId runs inside addToCart — strips GIDs automatically
        await addToCart(rawVariantId);
        printBrowserConsole(`"${productTitle}" added to cart`);

        const result = await toggleWishlist(TOGGLE_WISHLIST_DATA_URL, CUSTOMER_ID, buttonForToggle);
        printBrowserConsole("Toggle result:", undefined, result);

        if (result?.success && result.added === false) {
          row.remove();
        } else {
          printBrowserConsole("Unexpected toggle state — row kept", undefined, result);
        }
      } catch (error) {
        printBrowserConsole(`Error processing "${productTitle}":`, error);
        // Mark the visible button as failed so the user can see which item broke
        const visibleButton =
          row.querySelector("td.w-30pcnt .move-wishlist-to-cart") || buttonForToggle;
        visibleButton.textContent = "Failed";
        visibleButton.disabled    = false;
      }
    }
    // ── END CORE FIX ────────────────────────────────────────────────────────

    removeWishlistOverlayLoader();
    showEmptyStateIfNeeded();

    moveAllButton.disabled    = false;
    moveAllButton.textContent = "Add all items to cart";
  });
};

// ─── Boot ─────────────────────────────────────────────────────────────────────

document.addEventListener("DOMContentLoaded", async function () {
  init();
  printBrowserConsole("DOMContentLoaded event fired, wishlist script is ready");

  if (window.cffCustomer) {
    await initIfUserLoggedIn();
    addProductToWishlist();
    removeIndividualWishlistItem();
    addIndividualWishlistItemToCart();
    addAllWishlistItemsToCart();
    observeDOMChanges();
  } else {
    const favoriteItems = document.querySelectorAll(".ib-favorite-heart");
    favoriteItems.forEach((item) => {
      item.addEventListener("click", function () {
        document.querySelector(".ib-login-alert.popup").style.display = "flex";
      });
    });
  }
});

// Fallback for dynamically-injected hearts (e.g. colour swatch changes)
document.body.addEventListener("click", function (e) {
  const heart = e.target.closest(".ib-favorite-heart");
  if (heart && !window.cffCustomer) {
    document.querySelector(".ib-login-alert.popup").style.display = "flex";
    e.preventDefault();
    return false;
  }
});

function observeDOMChanges(targetNode = document.body, delay = 300) {
  const config = { childList: true, subtree: true };
  let timeoutId = null;
  const observer = new MutationObserver(function () {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => addProductToWishlist(), delay);
  });
  observer.observe(targetNode, config);
  return observer;
}